
















































































































import Vue from 'vue';

import { Internacao } from '../../../../back/src/entity/Internacao';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePacientesResumo from '../pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../pacientes/ThePacientesObservacoesAlert.vue';
import { calculoIdadeGestacional } from '../../utils/functions';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

export default Vue.extend({
  name: 'TheInternacoesTabelaAgendadas',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
  },
  props: {
    internacoes: {
      type: Array as () => Internacao[],
      required: true,
    },
  },
  data() {
    return {
      dialogResumoPaciente: false,
      internacaoSelecionada: null,
      headers: [
        {
          value: 'datetime_agendamento',
          text: 'Data agendada',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'paciente.nome',
          text: 'Paciente',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'paciente.paridade',
          text: 'Paridade',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'ig',
          text: 'IG atual',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'local',
          text: 'Local',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'quarto',
          text: 'Quarto',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'motivo',
          text: 'Motivo',
          sortable: false,
          class: 'text-no-wrap',
        },
      ],
    };
  },
  methods: {
    idadeGestacional(gestacao: Gestacao) {
      return calculoIdadeGestacional(gestacao);
    },
  },
});
